import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { dashboard } from "../apis/apiHandler";

export const dashboardData = createAsyncThunk(
    'dashboard/dashboard',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await dashboard(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    dashboardInfo: {},
    error: null,
    success: false,
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(dashboardData.pending, (state) => {
                state.loading = true;
            })
            .addCase(dashboardData.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.dashboardInfo = payload?.data;
            })
            .addCase(dashboardData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})

export default dashboardSlice.reducer;